import { render, staticRenderFns } from "./formbuilderEntityView.vue?vue&type=template&id=fb88f036&scoped=true"
import script from "./formbuilderEntityView.vue?vue&type=script&lang=js"
export * from "./formbuilderEntityView.vue?vue&type=script&lang=js"
import style0 from "./formbuilderEntityView.vue?vue&type=style&index=0&id=fb88f036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb88f036",
  null
  
)

export default component.exports